import { render, staticRenderFns } from "./draft_reviewed.vue?vue&type=template&id=6861cf6c&scoped=true&"
import script from "./draft_reviewed.vue?vue&type=script&lang=js&"
export * from "./draft_reviewed.vue?vue&type=script&lang=js&"
import style0 from "./draft_reviewed.vue?vue&type=style&index=0&id=6861cf6c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6861cf6c",
  null
  
)

export default component.exports